import {ChangeDetectionStrategy, Component, CUSTOM_ELEMENTS_SCHEMA, inject} from '@angular/core';
import {NachrichtenService} from "../../core/services/apiservices/nachrichten.service";

@Component({
    selector: 'kokos-test',
    imports: [],
    templateUrl: './test.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TestComponent {

    nullVar: string = null;

    private readonly nachrichtenService = inject(NachrichtenService)

    throwNullpointer() {
        console.log(this.nullVar.trim());
    }

    throwApiError() {
        this.nachrichtenService.sendNachricht(null).subscribe(result => {
          console.log(result);
        });
    }
}
